<!--
 * @Author: 张天昊
 * @Date: 2024-05-21 16:50:29
 * @LastEditTime: 2024-11-05 11:26:56
 * @LastEditors: 张天昊
 * @Description: 附件面板
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/FilePanel.vue
-->
<script>
import { defineComponent, computed, ref } from 'vue';
import BlockWithTitle from './BlockWithTitle.vue';
import CardContainer from './CardContainer.vue';
import FileCell from './FileCell.vue';
import DataEmpty from './DataEmpty.vue';
import { usePanelMinHeight } from '../composables/usePanelMinHeight';
import { useFilePreview } from '../composables/useFilePreview';
import { FilePreviewer } from '@/components/FilePreviewer';
import store from '@/store';

export default defineComponent({
  components: {
    BlockWithTitle,
    CardContainer,
    FileCell,
    DataEmpty,
    FilePreviewer
  },
  setup() {
    const detailInfoFiles = computed(() =>
      store.state.itineraryUniversal.detailInfo.value
        ? store.state.itineraryUniversal.detailInfo.value.itineraryInfoMessage
        : {}
    );
    const fieldGroup = {
      travelContract: '境内旅游合同（云南省内旅游用）',
      provinceOutTravelContract: '境内旅游合同（云南省外旅游用）',
      outboundTravelContract: '出境旅游合同',
      receptionAgreement: '旅行社单项委托合同',
      cooperateContract: '组团社与地接社合同',
      insurancePolicy: '确认件',
      carContract: '包车合同'
    };
    const fieldGroupEnties = Object.entries(fieldGroup);
    const isEmpty = computed(
      () =>
        Object.keys(fieldGroup)
          .map((prop) => getFileListByField(prop).length)
          .reduce((prev, curr) => prev + curr, 0) === 0
    );
    const { filePreviewerInst, onPreview } = useFilePreview();
    function getFileListByField(prop) {
      const value = detailInfoFiles.value[prop];
      return value ? value.split(',') : [];
    }
    const { panelMinHeight } = usePanelMinHeight();
    return {
      filePreviewerInst,
      fieldGroup,
      fieldGroupEnties,
      isEmpty,
      getFileListByField,
      onPreview,
      panelMinHeight
    };
  }
});
</script>

<template>
  <div class="px-12 pt-20" :style="{ minHeight: panelMinHeight }">
    <DataEmpty v-if="isEmpty" />
    <template v-else>
      <template v-for="[prop, title] in fieldGroupEnties">
        <BlockWithTitle
          v-if="getFileListByField(prop).length"
          :key="title"
          :title="title"
          class="[&:not(:first-child)]:mt-20"
        >
          <CardContainer>
            <template v-for="(url, index) in getFileListByField(prop)">
              <van-divider
                v-if="index > 0"
                :key="index"
                class="custom-divider"
              />
              <FileCell :key="url" :url="url" @click="onPreview" />
            </template>
          </CardContainer>
        </BlockWithTitle>
      </template>
    </template>
    <FilePreviewer ref="filePreviewerInst" />
  </div>
</template>

<style scoped>
.custom-divider {
  margin: 16px 0;
}
</style>
